import { Directive, HostListener, TemplateRef, ViewContainerRef } from '@angular/core';

import { ConditionalDirectiveBase } from 'src/app/directives/conditional-directive-base';

@Directive({
    selector: '[appMobileOnly]',
    standalone: false
})
export class MobileOnlyDirective extends ConditionalDirectiveBase {
  private readonly MOBILE_MAX_WIDTH = 575; // based off bootstrap xs media-query

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef
  ) {
    super(templateRef, viewContainer);
  }

  @HostListener('window:resize', ['$event'])
  onResize(_) {
    this.updateView();
  }

  shouldRenderElement(): boolean {
    return window.innerWidth <= this.MOBILE_MAX_WIDTH;
  }
}
